import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

/** Custom settings layout (profile, API keys, auth providers, admin cards). */
const settingsFeature = userSettingsPlugin.withOverrides({
  extensions: [
    userSettingsPlugin.getExtension('page:user-settings').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            path: '/settings',
            noHeader: true,
            loader: async () => {
              const { default: SettingsPage } = await import(
                '../components/settings/SettingsPage'
              );
              return <SettingsPage />;
            },
          },
        });
      },
    }),
  ],
});

export default settingsFeature;
